<div id='overlay'>
    <div class="simple-loader-wrapper">
      <mat-spinner *ngIf="isOwnerOpEnabled || isBennettEnabled" class="simple-loading-ownerOp" diameter='60'></mat-spinner>
      <mat-spinner *ngIf="isITMEnabled" class="simple-loading-ITM" diameter='60'></mat-spinner>
      <mat-spinner *ngIf="isMercerEnabled || isEFSEnabled" diameter='60'></mat-spinner>
    </div>  
  </div>